/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { getLeafBlockComponent, Empty } from '../block';
import { prefixContainer, listItemPrefix, blockQuotePrefix } from './styles';
import { useTheme } from '../../theme';
const TopLevelComponent = React.forwardRef((props, ref) => {
    const { element, children, ...restProps } = props;
    const theme = useTheme();
    const mdastNode = element.mdastNode;
    if (!mdastNode) {
        return (jsx(Empty, Object.assign({}, restProps, { ref: ref }), children));
    }
    const flattenedMdastAncestors = element.flattenedMdastAncestors;
    if (!flattenedMdastAncestors) {
        return (jsx(Empty, Object.assign({}, restProps, { ref: ref }), children));
    }
    const LeafBlockComponent = getLeafBlockComponent(mdastNode);
    const prefixComponents = flattenedMdastAncestors
        .map((ancestor, i) => {
        switch (ancestor) {
            case 'blockquote':
                return (jsx("span", { css: [
                        blockQuotePrefix,
                        {
                            '&::before': {
                                backgroundColor: theme.colors.blockQuote.marker,
                            },
                        },
                    ], key: `b_${i}` }));
            case 'listItem':
                return (jsx("span", { css: [
                        listItemPrefix,
                        {
                            '&::before': {
                                backgroundColor: theme.colors.listItem.marker,
                            },
                        },
                    ], key: `l_${i}` }));
            default:
                return undefined;
        }
    })
        .filter((c) => c != null);
    return (jsx(LeafBlockComponent, Object.assign({}, restProps, { ref: ref }),
        children,
        prefixComponents.length > 0 && (jsx("div", { css: prefixContainer, contentEditable: false }, prefixComponents))));
});
TopLevelComponent.displayName = 'TopLevelComponent';
export default React.memo(TopLevelComponent);
//# sourceMappingURL=index.js.map